export const dotcomDefaultAppSettings = {
  default: {
    loginAvailable: true,
  },
};
